import React from 'react';
import './ResultTable.scss';

const ResultsTable = ({
  data
}) => {

  return (
    <table border="1">
      <thead>
        <tr>
          <th>Name</th>
          <th>Studies</th>
          <th>Time Reviewing</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            <td>{row.name}</td>
            <td>{row.studies}</td>
            {/* <td>{row.timeReviewing}</td> */}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ResultsTable;
